import { ReactElement } from 'react';
import { useSelector } from 'react-redux';

// Hooks.
import { useAuth } from 'hooks';

// Store + Core
import { userProfileFullNameSelector } from 'store/profile/selectors';

// Styles
import styles from './Welcome.module.scss';
import { Box } from '@mui/material';

export const Welcome = (): ReactElement => {
  const [account, { isAuthenticated }] = useAuth();
  const fullName: string = useSelector(userProfileFullNameSelector);

  return (
    <div className={styles.container}>
      {isAuthenticated ? (
        <Box className={styles.welcomeBox}>
          <h2 data-testid="account-welcome-message">
            <div className={styles['welcome-prompt']}>{`Welcome back, ${fullName}`}</div>
            {account?.name}
          </h2>
        </Box>
      ) : (
        // Logged out state message
        <Box className={styles.listBox}>
          <Box className={styles.flexBox}>
            <h2 data-testid="guest-welcome-message">CME Made</h2>
            <h2 className={styles.simple}>&nbsp;Simple</h2>
          </Box>
          <ul>
            <li>Find CME</li>
            <li>Create a profile to view CME credits reported on your behalf</li>
            <li>Download and share your transcript</li>
            <li>
              Rest easy! Your credits are reported by participating CME organizers and shared with collaborating
              licensing and certifying boards
            </li>
          </ul>
        </Box>
      )}
    </div>
  );
};
